import { ReactNode } from 'react';

// TODO fix fsd
import { SendMoneyFlowModal } from '@/widgets/widgets-slider';

import { Plus2 } from '@/shared/assets';
import { ROUTES, RoutePath } from '@/shared/lib';
import {
  Button,
  CustomizeCloseButton,
  DashboardCustomizationBtn,
} from '@/shared/ui';

export const MOBILE_HEADER_BUTTONS_BY_ROUTES: Record<RoutePath, ReactNode> = {
  [ROUTES.ROOT]: <DashboardCustomizationBtn />,
  [ROUTES.PAYMENTS]: (
    <SendMoneyFlowModal defaultStep="add-recipient">
      <Button variant="brand-500" size="d-sm" className="w-fit">
        <Plus2 className="!size-6" />
        Add recipient
      </Button>
    </SendMoneyFlowModal>
  ),
  // [ROUTES.CARDS]: (
  //   <CreateCardModal>
  //     <Button variant="brand-500" size="d-sm" className="w-fit">
  //       <Plus2 className="!size-6" />
  //       New card
  //     </Button>
  //   </CreateCardModal>
  // ),
  [ROUTES.CUSTOMIZE]: <CustomizeCloseButton />,
};
